/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "/@lib@/commons/registry.js";
import "/@lib@/core/core_Perms.js";

const r = REG.reg;
r.newPerm("ui.apps.jobs.show", "show.jobs", 0);
r.newPerm("ui.apps.logs.show", "admin.logs", 0);
